import React, { useState, useEffect } from "react";
import AppCategoryRow from "./AppCategoryRow";
// import useAppMonitoring from './useAppMonitoring';
import useFirebase from "../../../../../useFirebase";
import useDurationOption from "../../../../customHooks/durationOption";
import Select from "react-select";
import { getCategoryStatusValue } from "../../../../../utils/helper";

const AppsCategoriesBlock = ({
  deviceSelected,
  appMonitoring,
  setAppMonitoring,
  handleAppCategoryChange,
  handleAllSelect,
  handleCategoryStatusChange,
  getLangTranslation,
}) => {
  const [filter, setFilter] = useState("ALL");
  const [filteredData, setFilteredData] = useState();
  const { categoryOptionsFunction } = useDurationOption();
  const [sortedData, setSortedData] = useState([]);

  const categoryOptions = categoryOptionsFunction();

  useEffect(() => {
    if (appMonitoring) {
      let appCategories = [...(appMonitoring?.appCategory || [])];
      if (filter === "ALL") {
        setFilteredData(appCategories);
      } else if (filter === "ALLOW") {
        appCategories = appCategories?.filter(
          (item) => item?.categoryStatus === 0 && item?.blockedByAdmin === 0
        );
      } else if (filter === "BLOCK") {
        appCategories = appCategories?.filter(
          (item) => item?.categoryStatus === 1 || item?.blockedByAdmin === 1
        );
      } else if (filter === "WARN") {
        appCategories = appCategories?.filter(
          (item) => item?.categoryStatus === 2 && item?.blockedByAdmin === 0
        );
      }
      setFilteredData(appCategories);
    }
  }, [appMonitoring, filter]);

  useEffect(() => {
    const temp = filteredData?.map((item) => {
      return { ...item, blockStatus: getCategoryStatusValue(item) };
    });
    temp?.sort((a, b) => b.blockStatus - a.blockStatus);
    setSortedData(temp);
  }, [filteredData]);


  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-3 mb-6">
            {/*<div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check ">
                <input
                  className="form-check-input"
                  id="ALL_SELECT"
                  type="checkbox"
                  name="ALL_SELECT"
                  checked={
                    appMonitoring?.appCategory?.length > 0 &&
                    appMonitoring?.appCategory?.filter(
                      (item) => !item?.isChecked
                    )?.length < 1
                  }
                  onChange={handleAllSelect}
                />
                <label
                  className="form-check-label text-nowrap text-dark"
                  htmlFor="enableScreenshot"
                >
                  {getLangTranslation(
                    "MANAGE_NOTIFICATION_SELECT_ALL",
                    "Select All"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
                onClick={() => handleCategoryStatusChange("ALLOW")}
              >
                <i className="icon-check-fill success-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_ALLOWED", "Allow")}
              </button>
              <button
                className="btn btn-outline-warning d-inline-flex align-items-center gap-1 text-nowrap me-3"
                onClick={() => handleCategoryStatusChange("WARN")}
              >
                <i className="icon-info-triangle-fill warning-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_WARNED", "Warn")}
              </button>
              <button
                className="btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap me-3"
                onClick={() => handleCategoryStatusChange("BLOCK")}
              >
                <i className="icon-ban danger-icon fs-5" />{" "}
                {getLangTranslation(
                  "APP_WEB_CATEGORY_STATUS_BLOCKED",
                  "Blocked"
                )}
              </button>
                </div>*/}
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <Select
                className="custom-select col-md-3"
                classNamePrefix="custom-select"
                placeholder="Select Category"
                options={categoryOptions}
                value={
                  categoryOptions?.find((item) => item?.value === filter)
                }
                onChange={(val) => {
                  setFilter(val.value);
                }}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle">
                    <div className="form-check">
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation(
                          "APPLICATION_CATEGORY",
                          "Application Category"
                        )}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle">
                    {getLangTranslation("DEVICE_DETAIL_ACTION", "Actions")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData?.map((app) => {
                  return (
                    <AppCategoryRow
                      item={app}
                      key={app?.id}
                      handleAppCategoryChange={handleAppCategoryChange}
                      getLangTranslation={getLangTranslation}
                      handleCategoryStatusChange={handleCategoryStatusChange}
                      deviceSelected={deviceSelected}
                    />
                  );
                })}
              </tbody>
            </table>

            {filteredData?.length === 0 && (
              <div className="text-center my-3">
                --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AppsCategoriesBlock;
